import {Nav,Home,Seats,Embed,SeatsDetail,Search,Footer,HistoricalElection,PollsDrawer,NotificationBar,OnboardingHint,SeatOnly} from './components/index';
import {Routes,Route, useLocation} from 'react-router-dom';
import { useScrollDepth } from './utils/useScrollDepth';

const App = () => {
  const { pathname } = useLocation();
  // Chrome-less routes: /embed (iframe embeds) and /seatonly (broadcast tool).
  const isChromeless = pathname === "/embed" || pathname === "/seatonly";

  const routeLabel =
    isChromeless ? null
    : pathname === '/' ? 'home'
    : pathname.startsWith('/seats/') ? 'seat_detail'
    : pathname === '/seats' ? 'seats'
    : pathname === '/historical' ? 'historical'
    : pathname;
  useScrollDepth(routeLabel);
  return (
    <div className='app'>

      { !isChromeless ? <NotificationBar/> : null }
      { !isChromeless ?
      <div className="navbar">
        <Nav/>
      </div>
       : null}
      <div className="main">
      { !isChromeless ?
      <Search/> : null }
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/embed" element={<Embed/>}/>
          <Route path="/seatonly" element={<SeatOnly/>}/>
          <Route path="/seats" element={<Seats/>}/>
          <Route path="/seats/:state" element={<SeatsDetail/>}/>
          <Route path="/seats/:state/:parliment" element={<SeatsDetail/>}/>
          <Route path="/historical" element={<HistoricalElection/>}/>
          <Route path="*" element={<p style={{textAlign:'center'}}>Error 404</p>}/>
        </Routes>
      </div>
      { !isChromeless ?
      <div className='footer'>
        <Footer/>
      </div>
      : null}
      { !isChromeless ? <PollsDrawer/> : null }
      {/* OneSignal push disabled for this branch. Re-enable by restoring
          <PushPrompt/> here and its import above (PushPrompt owns OneSignal.init). */}
      {/* { !isChromeless ? <PushPrompt/> : null } */}
      { !isChromeless ? <OnboardingHint/> : null }
    </div>
  )
}

export default App